<template>
  <div class="introduce-frame">
    <a class="anchor" id="dotJjtjs"></a>
    <div class="home-title-bt">
      <div class="home-t-bg">Group Introduction</div>
      <p>集团介绍</p>
    </div>
    <div class="introduce-main">
      <div
        class="introduce-t wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay=".2s"
      >
        <p style="font-weight: 600;">业务布局</p>
        百昌科技集团专注于传统资产处置与科技产品的融合。在传统处置领域，我们凭借深厚的行业经验与专业团队，为金融机构、国央企、资产管理公司（AMC）以及类金融机构等上千家客户提供高效、精准的资产处置服务。同时，集团致力于大数据、人工智能、区块链等技术在特殊资产领域的创新应用，自主研发了多款科技产品，赋能资产处置的各个环节，优化了服务流程，显著提升了服务的效率和质量。
      </div>
      <div
        class="introduce-t wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay=".3s"
        style="margin-bottom:10px"
      >
        <p style="font-weight: 600;">运营网络</p>
        百昌科技采取上海、北京双总部运营模式，并在全国范围内开设了 17
        家控股子公司，形成了覆盖全国的服务网络。各子公司均与当地大部分金融机构建立了深入的合作关系，精准提供属地化服务，真正打通特殊资产处置最后一公里。随着全国加盟商网络的逐步构建与拓展，集团的基础服务设施将更加完善。
      </div>
      <div
        class="introduce-t wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay=".3s"
        style="margin-bottom:10px"
      >
        <p style="font-weight: 600;">服务规模与成果</p>
        至今，百昌科技已累计服务资产规模达约 3 万亿，成功处置不良资产上千亿。
      </div>
      <div
        class="introduce-t wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay=".3s"
        style="margin-bottom:100px"
      >
        <p style="font-weight: 600;">人才团队</p>
        百昌科技拥有一支高素质、专业化的人才团队，包括数位博士后、博士，以及超过百位在金融、法律、互联网、不良资产处置等多个领域具备深厚实战经验的业界精英，为公司的持续创新与发展注入了源源不断的活力。
      </div>
      <!-- <div class="video-frame">
        <div class="video-bg">
          <img src="../../../assets/images/join/join-bg.png" alt="" />
        </div>
        <div class="video-cover">
          <img src="../../../assets/images/join/video-bg.png" alt="" />
        </div>
        <div class="video-btn">
          <div class="video-btn-n" @click="play">
            <img
              class="video-btn-sj"
              src="../../../assets/images/join/play.png"
              alt=""
            />
          </div>
        </div>
      </div> -->
    </div>
    <div class="play-frame" v-show="playBol">
      <div class="play-video">
        <div class="play-close" @click="close">
          <img src="../../../assets/images/join/close.png" alt="" />
        </div>
        <video
          id="movie"
          type="video/mp4"
          controls
          width="850px"
          height="480px"
          src="https://cdn-files.bcpai.com/videos/360pai2022.mp4"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "introduce",
  data() {
    return {
      playBol: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW().init();
    });
  },
  methods: {
    play() {
      this.playBol = true;
      let video = document.getElementById("movie");
      video.play();
    },
    close() {
      this.playBol = false;
      let video = document.getElementById("movie");
      video.pause();
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes ripple {
  0% {
    opacity: 0.8;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}
@-webkit-keyframes ripple {
  0% {
    opacity: 0.8;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}
.introduce-frame {
  position: relative;
  /*height: 1240px;*/
  .anchor {
    position: absolute;
    opacity: 0;
    top: -200px;
  }
  .introduce-main {
    position: relative;
    padding-top: 60px;
    .introduce-t {
      font-size: 18px;
      font-family: "SourceHanSansCN-Regular";
      color: #333333;
      line-height: 36px;
      padding: 0 70px 35px;
    }
    .video-frame {
      position: relative;
      width: 1032px;
      height: 770px;
      margin: 0 auto;
      .video-bg {
        position: absolute;
        width: 1032px;
        height: 841px;
        overflow: hidden;
        img {
          display: block;
          width: 1032px;
          height: 841px;
        }
      }
      .video-cover {
        width: 728px;
        height: 460px;
        overflow: hidden;
        position: absolute;
        left: 150px;
        top: 30px;
        img {
          display: block;
          width: 728px;
          height: 460px;
        }
      }
      .video-btn {
        position: absolute;
        left: 50%;
        height: 100px;
        width: 100px;
        margin-left: -50px;
        top: 200px;
        cursor: pointer;
        .video-btn-n {
          display: inline-block;
          padding: 0;
          height: 100px;
          width: 100px;
          line-height: 60px;
          font-size: 20px;
          text-align: center;
          background: #fff;
          color: #ff366b !important;
          position: absolute;
          border-radius: 50%;
          z-index: 1;
          .video-btn-sj {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -10px;
            margin-top: -17.5px;
            width: 30px;
            height: 35px;
            display: block;
            z-index: 2;
          }
          &::after {
            content: "";
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 1;
            background-color: #fff;
            border-radius: 50px;
            animation: ripple 1s linear infinite;
            -webkit-transform: scale(1);
            transform: scale(1);
            transition: all 0.5s ease-in-out;
          }
        }
      }
    }
  }
  .play-frame {
    position: fixed;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .play-video {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 850px;
      height: 480px;
      margin-left: -425px;
      margin-top: -240px;
      .play-close {
        position: absolute;
        width: 30px;
        height: 30px;
        overflow: hidden;
        cursor: pointer;
        right: -15px;
        top: -15px;
        z-index: 1;
        img {
          width: 30px;
          height: 30px;
          display: block;
        }
      }
    }
  }
}
</style>
